// extracted by mini-css-extract-plugin
export default {"modalFooter":"Styles-module__modalFooter--b485"};